<template>
  <div>
    <b-modal
      size="lg"
      v-model="visible"
    >
    <template slot="modal-title">
      {{titulo}}
    </template>

      <div>
        <b-row>
          <b-col lg="12">
            <b-form>
              <b-card-body>
                <b-row>
                  <b-col sm="6">
                    <!-- id -->
                    <b-form-group
                      :label="crearLabel('Código', 'pricodigo', 'datosFormulario')"
                      label-for="pricodigo">
                      <b-form-input
                        id="pricodigo"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.pricodigo"
                        :disabled="campoBloqueado('pricodigo', 'datosFormulario')"
                        @change="validarCampo('pkg_anapp_proveedores', 'pricodigo', $event, 'datosFormulario')">
                      </b-form-input>
                      <span class="error-validacion-campo">
                          {{ mensajeValidacionCampo.pricodigo }}
                      </span>
                    </b-form-group>


                    <b-form-group label="Código Sujeto" label-for="elementsAppendButton" :horizontal="false">

                      <b-input-group> 

                      <b-form-input 

                      id="pricodnum"
                      type="text"
                      placeholder=""
                      v-model="datosFormulario.pricodnum"
                      :disabled="campoBloqueado('pricodnum', 'datosFormulario')"
                      @change="validarCampo('pkg_anapp_proveedores', 'pricodnum', $event, 'datosFormulario')">

                      </b-form-input>

                      <b-input-group-prepend class="input-group-append">

                      <b-button type="button" class="fa fa-search" variant="primary" 
                      @click="seleccionarSujeto('Seleccionar Proveedor', 'seleccionarSujeto')"
                      ></b-button>

                      </b-input-group-prepend>

                      </b-input-group>

                      <span class="error-validacion-campo">

                      {{ mensajeValidacionCampo.pricodnum }}

                      </span>

                    </b-form-group>


                    <b-form-group
                        :label="crearLabel('Tipo Informe', 'infinforme', 'datosFormulario')"
                        label-for="infinforme"
                      >  
                      <b-form-select 
                        :options="tipoInforme"  
                        v-model="datosFormulario.pritipoinf"
                        :disabled="campoBloqueado('pritipoinf', 'datosFormulario')"
                        @change="validarCampo('pkg_anapp_proveedores', 'pritipoinf', $event, 'datosFormulario')"
                      >
                      </b-form-select>
                      
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.pritipoinf }}
                      </span>
                    </b-form-group>

                    

                    <b-form-group
                    :label="crearLabel('Fecha Modificación', 'prifmodif', 'datosFormulario')"
                    label-for="prifmodif_"
                    >
                    <b-input-group>
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                      </div>
                      <datepicker
                        :language="es"
                        format="dd-MM-yyyy"
                        :use-utc="true"
                        input-class="form-control"
                        id="prifmodif_"
                        placeholder=""
                        v-model="datosFormulario.prifmodif"
                        
                      >
                      </datepicker>
                    </b-input-group>
                    <span class="error-validacion-campo">
                      {{ mensajeValidacionCampo.prifmodif }}
                    </span>
                  </b-form-group>



                  </b-col>


                  <b-col sm="6">  
                    <!-- lineas de negocio -->
                    <b-form-group
                      :label="crearLabel('Nombre', 'prinombre', 'datosFormulario')"
                      label-for="prinombre">
                      <b-form-input
                        id="prinombre"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.prinombre"
                        :disabled="campoBloqueado('prinombre', 'datosFormulario')"
                        @change="validarCampo('pkg_anapp_proveedores', 'prinombre', $event, 'datosFormulario')">
                      </b-form-input>
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.prinombre }}
                      </span>
                    </b-form-group>

                    <b-form-group
                      :label="crearLabel('Adjuntar dirección en email', 'privadirec', 'datosFormulario')"
                      label-for="privadirec">
                      
                      <b-form-select 
                        :options="direccionPrivada"  
                        v-model="datosFormulario.privadirec"
                        :disabled="campoBloqueado('privadirec', 'datosFormulario')"
                        @change="validarCampo('pkg_anapp_proveedores', 'privadirec', $event, 'datosFormulario')"
                      >
                      </b-form-select>
                      
                      
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.privadirec }}
                      </span>
                    </b-form-group>

                    <b-form-group
                      :label="crearLabel('Usuario Modificación', 'priusumodif', 'datosFormulario')"
                      label-for="priusumodif">
                      <b-form-input
                        id="priusumodif"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.priusumodif"
                        :disabled="campoBloqueado('priusumodif', 'datosFormulario')"
                        @change="validarCampo('pkg_anapp_proveedores', 'priusumodif', $event, 'datosFormulario')">
                      </b-form-input>
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.priusumodif }}
                      </span>
                    </b-form-group>

                    <b-form-group
                      :label="crearLabel('Estado', 'priactivo', 'datosFormulario')"
                      label-for="priactivo">
                      <b-form-select 
                        :options="estados"  
                        v-model="datosFormulario.priactivo"
                        :disabled="campoBloqueado('priactivo', 'datosFormulario')"
                        @change="validarCampo('pkg_anapp_proveedores', 'priactivo', $event, 'datosFormulario')"
                      >
                      </b-form-select>
                     
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.priactivo }}
                      </span>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-form>
          </b-col>
        </b-row>
      </div>
      <div
        slot="modal-footer"
        class="w-100"
      >
        <p class="float-left"></p>
        <b-button
          type="submit"
          variant="secondary"
          class="float-right"
          @click="modalEditarProveedor = false; visible = false;"
        ><i class="fa fa-close"></i> Cerrar</b-button>
        <b-button
          type="submit"
          variant="primary"
          class="float-right"
          style="margin-right:8px;"
          @click="guardarProveedor"
        ><i class="fa fa-save"></i> Guardar</b-button>
      </div>
    </b-modal>
  
    <seleccionar-sujeto
      ref="refSeleccionarSujeto"
      @sujetoSeleccionado="sujetoSeleccionado($event)"
    ></seleccionar-sujeto>
  </div>
</template>
<script>

import axios from "axios";
import apiProveedores from "../../components/services/apiProveedores";
import { globalesMixin } from "../../components/mixins/globalesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import apiSeleccionarSujeto from "../../components/services/apiSeleccionarSujeto";
import SeleccionarSujeto from "../../components/global/SeleccionarSujeto";

export default {
  name: "EditarProveedor",
  mixins: [globalesMixin],
  data: function() {
    return {
      titulo: "",
      visible: false,
      modalEditarProveedor: false,
      modalAgregarProveedor: false,
      es: es,
      datosFormulario: {
        pricodigo: "",
        prinombre: "",
        pricodnum: "",
        privadirec: "",
        infinforme: "",
        priusumodif: "",
        rifmodif: "",
        prifmodif: "",
        priactivo: ""
      },
      tipoInforme: [],
      estados: [],
      direccionPrivada: [],
      datosFormularioEstado: [],
      mensajeValidacionCampo: {}
    };
  },
  components: {
    Datepicker,
    SeleccionarSujeto
  },
  methods: {
    obtenerProveedor(mail, usuario, id, tiporec) {
      this.titulo = "Editar Proveedor";
      this.mensajeValidacionCampo = {};
      return apiProveedores
        .buscar(mail, usuario, id, tiporec)
        .then(response => {

          this.datosFormulario.pricodigo = "";
          this.datosFormulario.prinombre = "";
          this.datosFormulario.pricodnum = "";
          this.datosFormulario.privadirec = "";
          this.datosFormulario.infinforme = "";
          this.datosFormulario.priusumodif = "";
          this.datosFormulario.rifmodif = "";
          this.datosFormulario.prifmodif = "";
          this.datosFormulario.priactivo = "";

          response.data = this.keysMinuscula(response.data);
          this.datosFormulario = response.data.res[0];
          this.datosFormularioEstado = response.data.festado;


          //Carga lista de tipo de informe
          var tiposInformes = new Array();
          var lista_tipos_informes = response.data.tpinformes;
          for(var i = 0; i < lista_tipos_informes.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_informes[i]["infcodigo"];
              obj.text = lista_tipos_informes[i]["infinforme"];
              tiposInformes.push(obj);
          }
          this.tipoInforme = tiposInformes;

          //Carga lista de estados
          var tiposEstados = new Array();
          var lista_tipos_estados = response.data.estados;
          for(var i = 0; i < lista_tipos_estados.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_estados[i]["codestado"];
              obj.text = lista_tipos_estados[i]["desestado"];
              tiposEstados.push(obj);
          }

          //Carga lista de direccion
          var tipoDirec = new Array();
          var lista_tipos_direc = response.data.direcciones;
          for(var i = 0; i < lista_tipos_direc.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_direc[i]["privadirec"];
              obj.text = lista_tipos_direc[i]["desc_direc"];
              tipoDirec.push(obj);
          }

          this.direccionPrivada = tipoDirec;
          this.estados = tiposEstados;

          this.modalEditarProveedor = true;
          this.visible = true;
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },
    pre_insertar(mail, usuario, p_pricodigo) {
      this.titulo = "Agregar Proveedor";
      this.mensajeValidacionCampo = {};
      return apiProveedores
        .pre_insertar(mail, usuario, p_pricodigo)
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          this.datosFormulario.pricodigo = "";
          this.datosFormulario.prinombre = "";
          this.datosFormulario.pricodnum = "";
          this.datosFormulario.privadirec = "";
          this.datosFormulario.infinforme = "";
          this.datosFormulario.priusumodif = "";
          this.datosFormulario.rifmodif = "";
          this.datosFormulario.prifmodif = "";
          this.datosFormulario.priactivo = "";
      
          this.datosFormulario.priusumodif = response.data.res[0].priusumodif;
          this.datosFormulario.priactivo = response.data.res[0].priactivo;
          this.datosFormulario.prifmodif = response.data.res[0].prifmodif;

          this.datosFormularioEstado = response.data.festado;
         
          //Carga lista de tipo de informe
          var tiposInformes = new Array();
          var lista_tipos_informes = response.data.tpinformes;
          for(var i = 0; i < lista_tipos_informes.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_informes[i]["infcodigo"];
              obj.text = lista_tipos_informes[i]["des_informe"];
              tiposInformes.push(obj);
          }
          this.tipoInforme = tiposInformes;

          //Carga lista de estados
          var tiposEstados = new Array();
          var lista_tipos_estados = response.data.estados;
          for(var i = 0; i < lista_tipos_estados.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_estados[i]["priactivo"];
              obj.text = lista_tipos_estados[i]["desc_activo"];
              tiposEstados.push(obj);
          }

          //Carga lista de direccion
          var tipoDirec = new Array();
          var lista_tipos_direc = response.data.direcciones;
          for(var i = 0; i < lista_tipos_direc.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_direc[i]["privadirec"];
              obj.text = lista_tipos_direc[i]["desc_direc"];
              tipoDirec.push(obj);
          }

          this.direccionPrivada = tipoDirec;
          this.estados = tiposEstados;
          this.modalAgregarProveedor = true;
          this.visible = true;
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },
    guardarProveedor(event) {
      event.preventDefault();
      this.$Progress.start();
      
      if (this.modalEditarProveedor){
        return apiProveedores
        .modificar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "datosFormulario"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.$emit("actualizaProveedores");
            this.modalEditarProveedor = false;
            this.visible = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
      }else if (this.modalAgregarProveedor) {
        return apiProveedores
        .insertar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "datosFormulario"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.$emit("actualizaProveedores");
            this.modalAgregarProveedor = false;
            this.visible = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
      }

      
    },
    seleccionarSujeto(titulo, tipoBusqueda) {
      this.$refs.refSeleccionarSujeto.modalSujeto = true;
      this.$refs.refSeleccionarSujeto.tituloModal = titulo;
      this.$refs.refSeleccionarSujeto.busqueda = "";
      this.$refs.refSeleccionarSujeto.data = [];
      this.$refs.refSeleccionarSujeto.tipoBusqueda = tipoBusqueda;
      this.$refs.refSeleccionarSujeto.accion = "nombre";
      this.$refs.refSeleccionarSujeto.textoAccion = "Nombre";
      
      this.$refs.refSeleccionarSujeto.tipo = "CLI";
      
    },
    sujetoSeleccionado(event) {
      this.$refs.refSeleccionarSujeto.modalSujeto = false;
      if (event.tipoBusqueda == "seleccionarSujeto") {
        this.datosFormulario.pricodnum = event.percodigo;
        this.datosFormulario.prinombre = event.pernombreimp;
        
      }
      
      
    },
  }
};
</script>
<style scoped>
</style>
